<template>
    <div class='welcome'>
        <h3 class='welcometit'>欢迎进入万年青物流平台</h3>
        <img class='welcomeimg' src='https://cargocnwebimage.oss-cn-beijing.aliyuncs.com/hhypc/hhywelcome1.png'/>
        <div class="welcomeBottom">
      
          <div class="wel-btn" href="https://hhy.cargocn.com/download/hhypdf/hhy-0825.pdf" target="_blank" @click="goVersion">
            点我查看更新文档
            <div class="dotted"></div>
          </div>
          <span>版本号：wnq20251204</span>
        </div>
    </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      imageList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      options: [],
      value: "",
    };
  },
  computed: {
    routes() {
      return this.$store.state.sharing.routes;
    }
  },
  mounted() {
  },
  methods: {
    goVersion(){
      var data = {
        name: '版本管理',
        path: '/version',
      }
      this.$root.$emit('routeEvent', data)
    },
  }
};
</script>

<style scoped  lang='scss'>
.welcome {
  margin: 50px;
}
.linkTo {
  width: 80px;
  height: 30px;
  background: #5888c3;
  border-radius: 10px;
  text-align: center;
  margin-left: 10px;
  color: #fff;
}
.welcometit{
  font-size: 50px;
font-weight: bold;
margin-left: 10%;
font-style: italic;
margin-top: 260px;
color: #0070b1;
}
.welcomeimg {
  width: 45%;
  position: absolute;
  right: 3%;
  bottom: 10px;
}
.welcomeBottom {
  position: absolute;
  right: 80px;
  bottom: 10px;
  font-size: 16px;
  color: #aaaaaa;
  display: flex;
  align-items: center;
  flex-direction: row;
}
  
.wel-btn {
    cursor: pointer;
    position: relative;
    width: 144px;
    height: 32px;
    background: #1890FF;
    border-radius: 2px 2px 2px 2px;
    text-align: center;
    color: #FFFFFF;
    font-size: 14px;
    line-height: 32px;
    cursor: pointer;
    margin-right: 16px;
    .dotted {
      position: absolute;
      right: -5px;
      top: -5px;
      width: 10px;
      height: 10px;
      background: #D93C3C;
      border-radius: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/welcomeY.vue